<template>
  <layout>
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header">Register</div>

            <div class="card-body">
              <form @submit.prevent="submit">
                <div class="form-group row">
                  <label
                    for="first_name"
                    class="col-md-4 col-form-label text-md-right"
                  >
                    First Name
                  </label>
                  <div class="col-md-6">
                    <TextInput
                      v-model="form.first_name"
                      :errors="$page.props.errors.first_name"
                      type="text"
                      autofocus
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for="last_name"
                    class="col-md-4 col-form-label text-md-right"
                  >
                    Last Name
                  </label>
                  <div class="col-md-6">
                    <TextInput
                      v-model="form.last_name"
                      :errors="$page.props.errors.last_name"
                      type="text"
                      autofocus
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label
                    for="email"
                    class="col-md-4 col-form-label text-md-right"
                  >
                    E-Mail Address
                  </label>
                  <div class="col-md-6">
                    <TextInput
                      v-model="form.email"
                      :errors="$page.props.errors.email"
                      type="email"
                      autofocus
                      autocapitalize="off"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label
                    for="password"
                    class="col-md-4 col-form-label text-md-right"
                  >
                    Password
                  </label>
                  <div class="col-md-6">
                    <TextInput
                      v-model="form.password"
                      :errors="$page.props.errors.password"
                      type="password"
                      autofocus
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for="password_confirmation"
                    class="col-md-4 col-form-label text-md-right"
                    >Confirm Password</label
                  >
                  <div class="col-md-6">
                    <TextInput
                      v-model="form.password_confirmation"
                      :errors="$page.props.errors.password_confirmation"
                      type="password"
                      autofocus
                    />
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <div class="col-md-4 offset-md-4">
                    <LoadingButton
                      :loading="sending"
                      class="btn btn-block btn-primary"
                      type="submit"
                      >Register</LoadingButton
                    >
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-8 offset-md-4">
                    Already have an account?
                    <inertia-link :href="route('login')"
                      >Login here.</inertia-link
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/Inputs/Text';

export default {
  components: {
    Layout,
    LoadingButton,
    TextInput,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      sending: false,
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        password_confirmation: null,
      }),
    };
  },
  mounted() {
    document.title = 'Register | Claus.ify';
  },
  methods: {
    submit() {
      this.sending = true;

      this.form.post(this.route('register'), {
        preserveScroll: true,
        onSuccess: () => {
          this.sending = false;
        },
      });
    },
  },
};
</script>
